export enum TrainingCategory {
  Warm = "warm",
  Main = "main",
  Stretching = "stretching",
}
